import { createFileRoute } from '@tanstack/react-router'
import { ClubPage } from '~/features/league/ClubPage'
import { clubQuery } from '~/features/league/queries'
import { loaderScope } from '~/features/matches/queries'

export const Route = createFileRoute('/_app/liga/vereine/$clubId')({
  loader: async ({ context, params }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId || !scope.permissions.includes('matches.read')) return
    // A missing club renders the page's own empty state, not the router's error.
    await context.queryClient.ensureQueryData(clubQuery(scope.teamId, scope.season, params.clubId)).catch(() => undefined)
  },
  component: function Verein() {
    return <ClubPage clubId={Route.useParams().clubId} />
  },
})
